// import logo from './logo.svg';
import { useState } from 'react';
import './App.css';
import WidgetHeader from './widget/WidgetHeader';
import WidgetContent from './widget/WidgetContent';
import WidgetFooter from './widget/WidgetFooter';
import WidgetIcon from './ada-engyj.png';
import Dyslexia from './OpenDyslexic-Bold.otf'

function App() { 
  const [state, setState] = useState(localStorage.getItem('isEngyjWidget') ? localStorage.getItem('isEngyjWidget') : 'open');
  const toggleState = () => {
    if (state === 'open') {
      setState('close');
      localStorage.setItem('isEngyjWidget', 'close')
    }
    if (state === 'close'){ 
      setState('open');
      localStorage.setItem('isEngyjWidget', 'open')
    }
  }
  return (
    <div className="App">
      <a href="javascript:;" className="widget-icon-wrapper" onClick={(e) => { toggleState()}}>
        <img src={`http://ada.engyj.com/0.1/${WidgetIcon}`} />
      </a>
      <div className={`engyj-body ${state}`}>
        <WidgetHeader toggleState={toggleState} />
        <WidgetContent />
        <WidgetFooter />
      </div>
    </div>
  );
}

export default App;
